import React from 'react';
import { connect } from 'react-redux';
import './TabTotalAds.css';

const TabTotalAds = (props) => {
  const { campaignKey, qcProcess } = props;
  const { totalQC, totalAds } = qcProcess[campaignKey] || {};
  const allQC = totalQC === totalAds ? 'green' : 'black';
  return (
    <small
      className="qc-process"
      style={{
        color: allQC
      }}
    >{`${totalQC || 0}/${totalAds || 0}`}</small>
  );
};

const mapStateToProps = (state) => {
  const { adQc } = state;
  const { qcProcess } = adQc;
  return {
    qcProcess,
    forceUpdate: new Date()
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabTotalAds);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/TabTotalAds.js